export default "__VITE_ASSET__db626f77__"